import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { HTTP_AP_ListTinyUrls_Request_Filter, HTTP_AP_ListTinyUrls_Request_Sort } from '@api-new/userservice';
import { TinyUrlTableRowModel } from '@platform/tiny-url/models/tiny-url-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const tinyUrlTableFilterDefaults: HTTP_AP_ListTinyUrls_Request_Filter = {
  referralCodeContains: '',
  nameOrDescription: '',
};

export const tinyUrlTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<TinyUrlTableRowModel, HTTP_AP_ListTinyUrls_Request_Sort>[] => {
  return [
    {
      columnLabel: 'Name',
      columnKey: 'name',
      type: RowDefinitionTypeEnum.Text,
      isFrozen: true,
      sortKey: 'byName',
      width: {
        min: '10rem',
        max: '10rem',
      },
    },
    {
      columnLabel: 'Referral Code',
      columnKey: 'referralCode',
      type: RowDefinitionTypeEnum.Text,
      sortKey: 'byReferralCodeContains',
      width: {
        min: '6rem',
        max: '6rem',
      },
    },
    {
      columnLabel: 'Created by',
      columnKey: 'createdByUserName',
      type: RowDefinitionTypeEnum.Text,
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.TinyUrlRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
        },
      ]),
      width: {
        min: '10rem',
        max: '10rem',
      },
    },
    {
      columnLabel: 'Link',
      columnKey: 'tinyUrl',
      type: RowDefinitionTypeEnum.CopyLink,
      width: {
        min: '10rem',
        max: '10rem',
      },
    },
    {
      columnLabel: 'Redirect Url',
      columnKey: 'redirectUrl',
      type: RowDefinitionTypeEnum.Text,
      width: {
        min: '10rem',
        max: '10rem',
      },
    },
  ];
};
